// extracted by mini-css-extract-plugin
export default {"notifications__item":"Notification_notifications__item__xJ17w"};